
import { defineComponent } from 'vue';
import { PersianDate } from '@/Utils/persian-date';
import store from '@/store';
import CustomButton from '@/components/vuetifyComponents/CustomButton.vue';

interface WithdrawalCryptoItem {
    id: string;
    createdAt: string;
    User?: {
        id?: string;
        name: string;
        email: string;
    };
    network: string;
    address: string;
    totalWithdrawAmount: number | string;
    finalAmountToSend: number | string;
    processingStage: string;
}

export default defineComponent({
    name: "withdrawalTransactionsTableComponent",

    components: { CustomButton },

    data() {
        return {
            persianDateConverter: new PersianDate(),
            loading: true,
            activeFilterButton: 'pending',
            buttons: [
                { title: 'در انتظار', value: 'pending' },
                { title: 'تایید شده', value: 'accept' },
                { title: 'رد شده', value: 'reject' },
            ],
            tableHeaders: [
                "تاریخ و ساعت",
                "نام کاربر",
                "ایمیل کاربر",
                "شبکه",
                "آدرس",
                "مقدار انتقال (تتر)",
                "گزینه ها"
            ],
            showAcceptDialog: false,
            showRejectDialog: false,
            selectedItem: null as WithdrawalCryptoItem | null,
            acceptLoading: false,
            rejectLoading: false,
            acceptMessage: '',
            rejectMessage: '',
        }
    },

    computed: {
        cryptoList() {
            return store.getters["panel/getWithdrawalscrypto"];
        }
    },

    methods: {
        persianDate(utcDateTime: string): string {
            return this.persianDateConverter.convert(utcDateTime, true);
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        openAcceptDialog(item: WithdrawalCryptoItem) {
            this.selectedItem = item;
            this.acceptMessage = ''; // Reset the message
            this.showAcceptDialog = true;
        },

        closeAcceptDialog() {
            this.showAcceptDialog = false;
            this.selectedItem = null;
            this.acceptMessage = '';
            this.acceptLoading = false;
        },

        async confirmAccept() {
            if (!this.selectedItem || !this.acceptMessage) return;

            this.acceptLoading = true;
            try {
                // Emit event to parent component with the item and acceptance message
                // this.$emit('accept-transaction', {
                //     item: this.selectedItem,
                //     message: this.acceptMessage
                // });

                const acceptTransaction = {
                    id: this.selectedItem.id,
                    usdt: this.selectedItem.finalAmountToSend,
                    user: this.selectedItem.User?.id,
                    link: this.acceptMessage
                }
                console.log("accept data ===>", acceptTransaction);
                store.dispatch("panel/acceptWithdrawalUsdtCharge", acceptTransaction);
                await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
                this.closeAcceptDialog();
            } catch (error) {
                console.error('Error accepting transaction:', error);
            } finally {
                this.acceptLoading = false;
            }
        },

        openRejectDialog(item: WithdrawalCryptoItem) {
            this.selectedItem = item;
            this.rejectMessage = ''; // Reset the message
            this.showRejectDialog = true;
        },

        closeRejectDialog() {
            this.showRejectDialog = false;
            this.selectedItem = null;
            this.rejectMessage = '';
            this.rejectLoading = false;
        },

        async confirmReject() {
            if (!this.selectedItem || !this.rejectMessage) return;

            this.rejectLoading = true;
            try {
                // Emit event to parent component with the item and rejection message
                // this.$emit('reject-transaction', {
                //     item: this.selectedItem,
                //     message: this.rejectMessage
                // });
                const rejectTransaction = {
                    id: this.selectedItem.id,
                    usdt: this.selectedItem.finalAmountToSend,
                    user: this.selectedItem.User?.id,
                    message: this.acceptMessage
                }
                store.dispatch("panel/rejectWithdrawalUsdtCharge", rejectTransaction);
                await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
                this.closeRejectDialog();
            } catch (error) {
                console.error('Error rejecting transaction:', error);
            } finally {
                this.rejectLoading = false;
            }
        },

        setFilterOfCryptoList(type: string): void {
            if (type === 'pending') {
                store.dispatch("panel/getWithdrawalsCryptoRequest")
                this.tableHeaders.slice(-1)
                this.tableHeaders = [
                    "تاریخ و ساعت",
                    "نام کاربر",
                    "ایمیل کاربر",
                    "شبکه",
                    "آدرس",
                    "مقدار انتقال (تتر)",
                    "گزینه ها"
                ];
            }

            if (type === 'accept') {
                store.dispatch("panel/getAcceptedWithdrawalsCryptoRequest");
                this.tableHeaders = [
                    "تاریخ و ساعت",
                    "نام کاربر",
                    "ایمیل کاربر",
                    "شبکه",
                    "آدرس",
                    "مقدار انتقال (تتر)",
                ];
            }

            if (type === 'reject') {
                store.dispatch("panel/getRejectedWithdrawalsCryptoRequest");
                this.tableHeaders = [
                    "تاریخ و ساعت",
                    "نام کاربر",
                    "ایمیل کاربر",
                    "شبکه",
                    "آدرس",
                    "مقدار انتقال (تتر)"
                ];
            }
            this.activeFilterButton = type;
        },
    },

    mounted() {
        this.loading = true;
        store.dispatch("panel/getWithdrawalsCryptoRequest").finally(() => {
            this.loading = false;
        });
    },
})
